import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import TitlePage from 'components/TituloPage';
import FormAtendente from 'containers/Forms/FormAtendente';
import { listarAtendente } from 'routes/paths';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';
import { formatterAtendenteBackToFront } from 'utils/formatter/atendente';
import { TODOS_CONDICOES_STATUS } from 'utils/consts';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import * as S from '../styles';

export default function PageVisualizarAtendente() {
  const dispatch = useDispatch();

  const atendente = useSelector(state => state.atendente?.atendenteDetalhar);

  const [optionsSetores, setOptionsSetores] = useState([]);

  React.useEffect(() => {
    dispatch(fetchBuscarSetores()).then(res => {
      setOptionsSetores(montarDadosInputSelect(res, 'id', 'nome'));
    });
  }, [dispatch]);

  const {
    control,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: formatterAtendenteBackToFront(atendente),
  });

  return (
    <S.Contain className="boxShadow">
      <TitlePage textTitle={'VISUALIZAR DE ATENDENTE'} backPage={listarAtendente} />
      <form>
        <FormAtendente
          errors={errors}
          control={control}
          getValues={getValues}
          handleChange={() => {}}
          optionsCargos={[{ value: atendente?.cargo?.id, label: atendente?.cargo?.descricao }]}
          optionsSituacoes={[
            {
              value: atendente?.situacao?.id,
              label: atendente?.situacao?.descricao,
            },
          ]}
          optionsCondicao={montarDadosInputSelect(TODOS_CONDICOES_STATUS, 'id', 'label')}
          optionsSetores={optionsSetores}
          handleSubmit={() => {}}
          onSubmit={() => {}}
          disabled={true}
        />
      </form>
    </S.Contain>
  );
}
